import { Constants, USER_ROLES } from '@pwc/pwc-deals-web-common';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAnalysis } from './analysesService';
import { getRichTextLibraryItemsByGroup } from '../contentLibrary/libraryItemService';

export const initialState = {
  loading: true,
  error: null,
  analysis: null,
};

export const getFreeformAnalysis = createAsyncThunk(
  'editFreeformAnalysis/getFreeformAnalysis',
  async ({ projectId, analysisId, contextStatusInfoItem }, thunk) => {
    const analysisData = await getAnalysis(projectId, analysisId);
    const isPwcUser =
      thunk.getState().loggedInUser.userRole === USER_ROLES.PWC_USER;

    const richTextLibraryItemIds = analysisData.sections.reduce(
      (acc, section) => {
        section.items.forEach((item) => {
          if (item.type === Constants.LIBRARY_ITEM_TYPES.RICH_TEXT.value) {
            acc.push(item.id);
          }
        });
        return acc;
      },
      []
    );

    if (richTextLibraryItemIds.length > 0) {
      await getRichTextLibraryItemsByGroup(
        projectId,
        {
          libraryItemIds: richTextLibraryItemIds,
        },
        contextStatusInfoItem,
        isPwcUser
      );
    }

    return analysisData;
  }
);

const freeformAnalysisSlice = createSlice({
  name: 'getFreeformAnalysis',
  initialState,
  reducers: {
    clearEditFreeformAnalysis: (state) => {
      state.loading = false;
      state.error = null;
      state.analysis = null;
    },
  },
  extraReducers: {
    [getFreeformAnalysis.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getFreeformAnalysis.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.analysis = payload;
    },
    [getFreeformAnalysis.rejected]: (state, { error }) => {
      state.loading = false;
      state.error = error;
      state.analysis = null;
    },
  },
});

export const { reducer: editFreeformAnalysisReducer } = freeformAnalysisSlice;

export const { clearEditFreeformAnalysis } = freeformAnalysisSlice.actions;

export const getFreeformAnalysisSelector = (state) =>
  state.editFreeformAnalysis;
